import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue")
  },
  {
    path: "/new-borrower",
    name: "NewBorrower",
    component: () => import("@/views/NewBorrower.vue")
  },
  {
    path: "/requests",
    name: "BorrowerRequests",
    component: () => import("@/views/BorrowerRequests.vue")
  },
  {
    path: "/new-credit",
    name: "NewCredit",
    component: () => import("@/views/NewCredit.vue")
  },
  {
    path: "/select-office",
    name: "SelectOffice",
    component: () => import("@/views/SelectOffice.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
